<template>
    <div>
        <div>
            <v-row class="event-row">
                <v-col class="d-flex justify-center align-center no-padding-top no-padding-bottom">
                    <img class="event-image" :src="'/img/svg/'+ event.event_category.icon +'.svg'">
                </v-col>
                <v-col class="event-time-col d-flex justify-center align-center no-padding-top no-padding-bottom">
                    {{event.start_time}}&nbsp;{{$t('event.until')}}<br>
                    {{event.end_time}}&nbsp;{{$t('event.time')}}
                </v-col>
                <v-col class="event-description-col d-flex flex-column justify-center no-padding-top no-padding-bottom">
                    <div class="event-description">{{event.description}}</div>
                    <div>{{event.location}}</div>
                </v-col>
            </v-row>
        </div>
        <v-row v-if="length === 2 && index==2" class="empty-event"></v-row>
        <v-row v-if="length === 1 && index==1" class="empty-event"></v-row>
    </div>
</template>
<style lang="scss">
.event-row{
    min-height: 13vh;
    height: 13vh;
    max-height: 13vh;
}
.event-image{
    height: 9vh !important;
}
.event-time-col{
    font: normal normal normal 3vh/4vh 'RobotoRegular' !important;
    color: $font-color !important;
    flex-grow: 2;
}
.event-description-col{
    font: normal normal normal 3vh/4vh 'RobotoRegular' !important;
    color: $font-color !important;
    flex-grow: 8;
}
.event-description{
    font: normal normal Bold 4vh/5vh 'RobotoRegular' !important;
}
.hide {
    opacity: 0;
}
</style>
<script>
export default {
    props: {
        event: {
            type: Object,
            required: true,
        },
        index: {
            type: Number,
            required: true
        },
        length: {
            type: Number,
            required: true
        },
    },
}
</script>
